import axios from 'axios'
import store from '../store'
import router from '../router'
import vue from 'vue'

// Establish the base URL
export let HTTP = axios.create({
  baseURL: process.env.API_BASE_URL
});

// Add a request interceptor
HTTP.interceptors.request.use(function (config) {
  // Add the latest authentication token before request is sent
  if (config.url && config.url.indexOf('amazonaws.com') === -1 && config.url.indexOf(process.env.COGNITO_URL) === -1) {
    config.headers.Authorization = 'Bearer ' + (store.state as any).user.token;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
HTTP.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && 401 === error.response.status) {
    if (!error.request || !error.request.responseURL.includes('/login')) {
      showSessionExpiredNotice();
      router.push('/login');
    }
  }
  return Promise.reject(error);
});

let sessionExpiredNoticeTimeOut: NodeJS.Timer;
function showSessionExpiredNotice () {
  clearTimeout(sessionExpiredNoticeTimeOut);
  sessionExpiredNoticeTimeOut = setTimeout( function () {
    vue.prototype.$notify({
      group: 'main',
      type: 'success',
      title: 'Your Session Has Expired',
      text: 'Please log in again.',
      duration: 5000
    });
  }, 500);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/httpCommonUtil.ts